<div class="card dashboardTable mt-2">
    <p-toolbar styleClass="mb-4">
        <ng-template pTemplate="left">
            <span class="selected-date">
                {{ date | date: 'longDate' }}
            </span>
            <!-- <button pButton icon="pi pi-fw pi-plus" label="Add Bank Details" (click)="openNew()"
                    class="p-button-success"></button> -->
            <!-- <button pButton pRipple  icon="pi pi-trash" class="ml-4 p-button-danger" (click)="deleteSelectedProducts()" [disabled]="!selectedBankAccounts || !selectedBankAccounts.length"></button> -->
        </ng-template>
        <ng-template pTemplate="right">
            <!-- <p-fileUpload accept=".jpeg,.pdf,.jpg" mode="basic" [maxFileSize]="5000000" label="Import" chooseLabel="Import" class="mr-2 inline-block"></p-fileUpload> -->
            <button (click)="menu.toggle($event)" pButton pRipple label="{{'EXPORT'| translate}}" icon="pi pi-download"
                class="p-button-help"></button>

            <p-menu #menu [popup]="true" [model]="appVerificationItems"></p-menu>
        </ng-template>
    </p-toolbar>
    <p-table #miSurvey [value]="pondData" dataKey="AppId_ProgID" [rows]="10" [paginator]="true" [globalFilterFields]="[
        'UserID',
		'Date_filter',
		'District',
		'Applicant_type',
		'ApplicationApproval',
		'ApplicationApproval_MR',
        'EstimateApproval',
        'EstimateApproval_MR',
		'PVApproval',
		'PVApproval_MR',

        ]" responsiveLayout="scroll" [rowHover]="true" dataKey="Scheme_Specific_Id"
        currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
        [showCurrentPageReport]="true">
        <ng-template pTemplate="caption">
            <div class="flex align-items-center justify-content-between">
                <h5 class="m-0">{{'MI_DA_REPORT'| translate}}</h5>
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="miSurvey.filterGlobal($any($event.target).value, 'contains')"
                        placeholder="{{'SEARCH'| translate}}" />
                </span>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>

                <th pSortableColumn="UserID">{{'USER_ID'| translate}}
                    <p-columnFilter type="text" field="UserId" display="menu"></p-columnFilter>
                    <p-sortIcon field="UserID"></p-sortIcon>
                </th>
                <th pSortableColumn="Date_filter">{{'DATE'| translate}}
                    <p-columnFilter type="text" field="Date_filter" display="menu"></p-columnFilter>
                    <p-sortIcon field="Date"></p-sortIcon>
                </th>
                <th pSortableColumn="District">{{'DISTRICT'| translate}}
                    <p-columnFilter type="text" field="District" display="menu"></p-columnFilter>
                    <p-sortIcon field="District"></p-sortIcon>
                </th>
                <th pSortableColumn="Applicant_type">{{'APPLICATION_TYPE'| translate}}
                    <p-columnFilter type="text" field="Applicant_type" display="menu"></p-columnFilter>
                    <p-sortIcon field="Applicant_type"></p-sortIcon>
                </th>
                <th pSortableColumn="ApplicationApproval">{{'APPLICATION_APPROVAL'| translate}}
                    <p-columnFilter type="text" field="ApplicationApproval" display="menu"></p-columnFilter>
                    <p-sortIcon field="ApplicationApproval"></p-sortIcon>
                </th>
                <th pSortableColumn="ApplicationApproval_MR">{{'APPLICATION_APPROVAL_MR'| translate}}
                    <p-columnFilter type="text" field="ApplicationApproval_MR" display="menu"></p-columnFilter>
                    <p-sortIcon field="ApplicationApproval_MR"></p-sortIcon>
                </th>
                <th pSortableColumn="EstimateApproval">{{'ESTIMATE_APPROVAL'| translate}}
                    <p-columnFilter type="text" field="EstimateApproval" display="menu"></p-columnFilter>
                    <p-sortIcon field="EstimateApproval"></p-sortIcon>
                </th>
                <th pSortableColumn="EstimateApproval_MR">{{'ESTIMATE_APPROVAL_MR'| translate}}
                    <p-columnFilter type="text" field="EstimateApproval_MR" display="menu"></p-columnFilter>
                    <p-sortIcon field="EstimateApproval_MR"></p-sortIcon>
                </th>
                <th pSortableColumn="PVApproval">{{'PV_APPROVAL'| translate}}
                    <p-columnFilter type="text" field="PVApproval" display="menu"></p-columnFilter>
                    <p-sortIcon field="PVApproval"></p-sortIcon>
                </th>
                <th pSortableColumn="PVApproval_MR">{{'PV_APPROVAL_MR'| translate}}
                    <p-columnFilter type="text" field="PVApproval_MR" display="menu"></p-columnFilter>
                    <p-sortIcon field="PVApproval_MR"></p-sortIcon>
                </th>

            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-pondData>
            <tr>
                <td>{{pondData.UserID}}</td>
                <td>{{pondData.Date_filter}}</td>
                <td>{{pondData.District}}</td>
                <td>{{pondData.Applicant_type}}</td>
                <td>{{pondData.ApplicationApproval}}</td>
                <td>{{pondData.ApplicationApproval_MR}}</td>
                <td>{{pondData.EstimateApproval}}</td>
                <td>{{pondData.EstimateApproval_MR}}</td>
                <td>{{pondData.PVApproval}}</td>
                <td>{{pondData.PVApproval_MR}}</td>

            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="7">No Data found.</td>
            </tr>
        </ng-template>

    </p-table>
</div>